// Components==============
import RootReflectionModal from 'components/UI/RootReflectionModal/RootReflectionModal';
import { motion } from 'framer-motion';
import { useMediaQ } from 'hooks/useMediaQ';
import React from 'react';
import Colors from './components/Colors/Colors';
import Dreams from './components/Dreams/Dreams';
import People from './components/People/People';
import Progress from './components/Progress/Progress';
import Reflection from './components/Reflection/Reflection';
import Skills from './components/Skills/Skills';
import Stats from './components/Stats/Stats';
import './Overview.module.scss';
// =========================

export default function Overview() {
  const scale1 = useMediaQ('min', 1325);
  // @ts-ignore
  const scale2 = useMediaQ('min', 1450);
  // @ts-ignore
  const noScale = useMediaQ('min', 1550);

  const framerWrapper = {
    initial: { scale: 0 },
    exit: { scale: 0 },
    mount: { scale: noScale ? 1 : scale2 ? 0.94 : scale1 ? 0.8475 : 1 },
  };

  return (
    <>
      <motion.div
        transition={{ duration: 0.8, staggerChildren: 5 }}
        variants={framerWrapper}
        initial="initial"
        exit="initial"
        animate="mount"
        styleName=" wrapper"
      >
        <Dreams />
        <Colors />
        <People />
        <Progress />
        <Reflection />
        <Skills />
        <Stats />
      </motion.div>
      <RootReflectionModal type="dream" />
    </>
  );
}
